import http from 'hub-http/clients/apiClient';
// @ts-expect-error Could not find a declaration file for module
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { Map as ImmutableMap, fromJS } from 'immutable';
export const createGetSocialChannels = ({
  httpClient = http
}) => () => {
  return httpClient.get('/broadcast/v2/channels').then(data => {
    return fromJS(data.map(channel => {
      return new ReferenceRecord({
        id: channel.channelKey,
        label: `${channel.accountType} - ${channel.name}`,
        referencedObject: ImmutableMap({
          id: channel.channelKey,
          label: `${channel.accountType} - ${channel.name}`
        })
      });
    }));
  });
};
export const getSocialChannels = createGetSocialChannels({
  httpClient: http
});